import { render } from "./CategoryListComponent.vue?vue&type=template&id=aa847c9a&scoped=true"
import script from "./CategoryListComponent.vue?vue&type=script&lang=js"
export * from "./CategoryListComponent.vue?vue&type=script&lang=js"

import "./CategoryListComponent.vue?vue&type=style&index=0&id=aa847c9a&scoped=true&lang=css"

import exportComponent from "/home/u1042/tmp/bet-clipcut-003-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa847c9a"]])

export default __exports__